import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { MessageCircle, X } from "lucide-react";

const StickyButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    let ticking = false;

    const toggleVisibility = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          if (window.scrollY > 300) {
            setIsVisible(true);
          } else {
            setIsVisible(false);
          }
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener("scroll", toggleVisibility, { passive: true });
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-6 right-6 z-50 allow-pointer">
      <Button asChild size="lg" className="rounded-full shadow-lg will-change-transform">
        <Link to="/contact" className="flex items-center gap-2">
          <MessageCircle className="h-5 w-5" />
          <span className="hidden sm:inline">Parler de mon projet</span>
        </Link>
      </Button>
    </div>
  );
};

export default StickyButton;